import type { bankingApiSpec } from "@wingspanhq/wingspan-api-types";

export const selectorActiveBankingAccount = (
  internalAccount: bankingApiSpec.InternalAccount
) => internalAccount.type === "Banking" && internalAccount.status === "Active";
